import { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Center,
  Container,
  Flex,
  Group,
  Loader,
  NumberFormatter,
  NumberInput,
  Paper,
  Stack,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { checkoutCredits, getProducts } from "../api";
import mixpanel from "../tracking";
import HeroFaq from "./FAQ";
import { IconCoins } from "@tabler/icons-react";
import { Link } from "wouter";

function checkout(dto, callback) {
  checkoutCredits(dto)
    .then((data) => {
      console.debug("redirecting to: " + data.redirectUrl, data);
      mixpanel.track("Checkout Credits");
      if (callback) callback();
      location.href = data.redirectUrl;
    })
    .catch((error) => {
      mixpanel.track("Checkout Credits FAIL");
      alert("Sorry, something went wrong: " + error);
      if (callback) callback();
    });
}


export const PlanPrepaid = () => {
  const [isLoading, setIsLoading] = useState(false);


  // const [products, setProducts] = useState([
  //   { id: 1, qty: 0, price: 9.9, credits: 2500, name: "Small" },
  //   { id: 2, qty: 1, price: 39.9, credits: 12500, name: "Medium" },
  //   { id: 3, qty: 0, price: 199.9, credits: 75000, name: "Large" },
  //   { id: 4, qty: 1, price: 7, credits: 1, name: "Small" },
  //   { id: 5, qty: 0, price: 25, credits: 5, name: "Large" },
  // ]);

  const [products, setProducts] = useState(null);

  useEffect(() => {
    getProducts().then((data) => {
      setProducts(data);
    });
  }, []);

  const calculatorRow = (index) => (
    <Table.Tr>
      <Table.Td>
        {products[index].name}
        <br />
        <Badge variant="light" rightSection={<IconCoins size={12} />}>
          <NumberFormatter thousandSeparator value={products[index].credits} />
        </Badge>
      </Table.Td>
      <Table.Td ta="right">
        <NumberFormatter
          thousandSeparator
          decimalScale={2}
          prefix="$ "
          fixedDecimalScale
          value={products[index].price}
        />
      </Table.Td>
      <Table.Td style={{ width: "90px" }} ta="right">
        <NumberInput
          min={0}
          max={3}
          value={products[index].quantity}
          onChange={(value) => {
            const amtCopy = [...products];
            amtCopy[index].quantity = value;
            setProducts(amtCopy);
          }}
          size="sm"
        />
      </Table.Td>
      <Table.Td ta="right">
        <NumberFormatter
          value={Math.min(products[index].quantity, 3) * products[index].price}
          decimalScale={2}
          prefix="$ "
          fixedDecimalScale
        />
      </Table.Td>
    </Table.Tr>
  );

  const getTotal = () => {
    let total = 0;
    for (let i = 0; i < products.length; i++) {
      total += Math.min(products[i].quantity, 3) * products[i].price;
    }
    return total;
  };

  return (
    <Container size="sm">
      <Stack spacing={40} mt="md" mb="xl" pt="md" pb="xl">
        <a id="start" />
        <Flex
          direction="column"
          gap={10}
          align="center"
          justify="start"
          mb="xl"
        >
          <Title>Buy Credits</Title>
          <Text ta="center" size="lg" fw={500}>
            Buy prepaid credits to create images and train your own AI models
            with ease!
            <br />
            Mix & match to suit your needs.
          </Text>
        </Flex>
        {/* <Flex
          direction="row"
          gap={10}
          align="center"
          justify="space-evenly"
          mb="xl"
        >
          <IconCurrencyEthereum size={50} />
          <IconCurrencyBitcoin size={50} />
          <IconCoinMonero size={50} />
          <IconCurrencyLitecoin size={50} />
          <IconCurrencySolana size={50} />
          <IconCurrencyRipple size={50} />
        </Flex> */}

        {products == null ? (
          <Stack align="center" mt="xl" fw={600}>
            <Loader />
            Loading...
          </Stack>
        ) : (
          <Table tabularNums>
            <Table.Tbody>
              <Table.Tr>
                <Table.Td fw={600} colSpan={4}>
                  Image Credits
                </Table.Td>
              </Table.Tr>
              {calculatorRow(0)}
              {calculatorRow(1)}
              {calculatorRow(2)}

              <Table.Tr>
                <Table.Td fw={600} colSpan={4} pt="lg">
                  Training Credits
                </Table.Td>
              </Table.Tr>

              {calculatorRow(3)}
              {calculatorRow(4)}

              <Table.Tr>
                <Table.Td colSpan={2} fw={600} ta="left">
                  TOTAL
                </Table.Td>
                <Table.Td colSpan={2} fw={600} ta="right">
                  <NumberFormatter
                    thousandSeparator
                    value={getTotal()}
                    decimalScale={2}
                    prefix="$ "
                    fixedDecimalScale
                  />
                </Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        )}

        <Group justify="flex-end">
          <Button
            loading={isLoading}
            disabled={!products || getTotal() === 0}
            // variant="gradient"
            // gradient={{ from: "grape", to: "pink.5", angle: 45 }}
            size="lg"
            mt="xl"
            onClick={() => {
              setIsLoading(true);
              checkout({ items: products }, () => setIsLoading(false));
            }}
          >
            Buy
          </Button>
        </Group>
        <Paper mt="lg" ta="center">
          <Text c="dimmed">
            Credits bought have a validity of 90 days from the moment of
            purchase.
          </Text>
        </Paper>
        <Paper mt="lg" ta="center">
          <Text c="dimmed">
            Explore our <Link to="/payment/plans">subscription plans</Link> for
            more options.
          </Text>
        </Paper>
        <Paper mt="lg" ta="center">
          <Text c="dimmed">
            Different image operations have different prices. Creating an AI
            image with default settings costs 50 credits, removing background
            from an image 30. Plugin operations&apos; cost may vary. Prices are
            subject to change.
          </Text>
        </Paper>
      </Stack>
      <HeroFaq />
      <Center>
        <Button
          component="a"
          size="lg"
          variant="gradient"
          gradient={{ from: "pink", to: "indigo", deg: 105 }}
          href="#start"
          mt="xl"
          mb="xl"
        >
          Take your pictures now!
        </Button>
      </Center>
    </Container>
  );
};
